import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-tt",
  "use": "icon-icon-tt-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-tt\">\n  <path fill=\"#fff\" d=\"M0 0h512v512H0z\" style=\"width:0\" />\n  <g fill-rule=\"evenodd\">\n    <path fill=\"#e00000\" d=\"M371 512 0 1v510.7l371 .3zM141 0l371 511V.2L141 0z\" />\n    <path d=\"M22.2.2h94.9l374.5 511.3h-97.9L22.2.2z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol